module.exports = __webpack_public_path__ + "08ea03c6e1181df436c9cced7bf31ae4.svg";